import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  trainingItemHeader: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  trainingButton: {
    marginTop: '8px',
  },
  trainingFooter: {
    padding: `${theme.spacing(2)} ${theme.spacing(1)} ${theme.spacing(1)}`,
    backgroundColor: theme.palette.background.paper,
  },
  addTrainingSetFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    padding: `${theme.spacing(1)} ${theme.spacing(1)} 0`,
    backgroundColor: theme.palette.background.paper,
  },
  trainerWrapper: {
    marginTop: theme.spacing(1),
  },
  trainerLabel: {},
  linkWrapper: {
    ...theme.mixins.appLink,
  },
  setWrapper: {
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(1),
    },
  },
  groupWrapper: {
    ...theme.mixins.appContainer,
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  headerWrapper: {
    [theme.breakpoints.down('md')]: {
      // padding: theme.spacing(0, 1),
    },
  },
  trainingTitle: {
    flex: 1,
    minWidth: 0,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
}));
